var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1890_25330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.74159 0.885525C4.43456 1.18667 4.1883 1.54983 4.0175 1.95334C3.8467 2.35685 3.75486 2.79243 3.74745 3.23411C3.74005 3.67579 3.81724 4.11451 3.97441 4.52411C4.13158 4.93371 4.36551 5.30579 4.66226 5.61815C4.959 5.93051 5.31248 6.17676 5.7016 6.3422C6.09071 6.50765 6.5075 6.5889 6.9271 6.5811C7.34669 6.57331 7.7605 6.47663 8.14383 6.29684C8.52716 6.11706 8.87216 5.85784 9.15825 5.53465C9.02575 7.8307 7.21492 9.64912 5.00034 9.64912C2.69867 9.64912 0.833252 7.68552 0.833252 5.26316C0.833252 2.93202 2.56075 1.02588 4.74159 0.885525Z",
    fill: "#171725"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1890_25330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10.5263,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.fcf940194a1533768119a00e3aad2a79.svg";
export { ForwardRef as ReactComponent };